import { render } from "./ProductInventorySpecificDays.vue?vue&type=template&id=e051c39c&ts=true"
import script from "./ProductInventorySpecificDays.vue?vue&type=script&lang=ts"
export * from "./ProductInventorySpecificDays.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__